import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function ChevronRightIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m9 18 6-6-6-6" />
    </StrokeIcon>
  );
}
